module.exports = __webpack_public_path__ + "img/bg-sports.257e71a8.jpg";